import { useRoutes } from 'react-router-dom';
import LazyLoadRoute from 'components/common/LazyLoadRoute';
import routes from './routes';
import useAuth from './hooks/Auth0';
import { IntlProvider } from 'react-intl';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export default function App() {
  const routing = useRoutes(routes);
  const queryClient = new QueryClient();

  useAuth();

  return (
    <IntlProvider locale='en'>
      <QueryClientProvider client={queryClient}>
        <LazyLoadRoute>{routing}</LazyLoadRoute>
        <Toaster />
      </QueryClientProvider>
    </IntlProvider>
  );
}
